import * as React from "react";
import {cs} from "@Common/react/chain-services";
import "./file-selector.scss";
import {Static2} from "@Common/react/static-2";
import {cx} from "emotion";

export const FileSelector = ({state}) => cs(
    ["ref", (_, next) => Static2({next})],
    ({ref}) => (
        <div className={cx("file-selector file-selector-a42u", {selected: state.value})}>
            <div {...{
                className: "fake-input",
                onClick: () => ref.get().click(),
            }}>
                <button xd-qa-type="button" xd-qa-name="Upload Address List Choose File">
                    CHOOSE FILE
                </button>
                <div className="name" xd-qa-type="label" xd-qa-name="Upload Address List File Name">
                    {state.value ? (
                        limitString(state.value[0].name, 50)
                    ) : (
                        "No File Chosen"
                    )}
                </div>
            </div>

            <input {...{
                type: "file",
                ref: ref.set,
                onChange: (e) => {
                    e.target.files?.length && state.onChange(e.target.files);
                },
            }} xd-qa-name="Choose File"/>

        </div>
    )
);

const limitString = (str, length) => {
    if (str.length <= length) {
        return str;
    }
    return str.substring(0, Math.floor(length / 2) - 3) + "..." + str.substring(str.length - Math.ceil(length / 2));
};
